import {
  ICustomReportChart,
  ICustomReportColumn,
  type ICustomReportFilter,
} from '@principle-theorem/principle-core/interfaces';
import {
  IAccessorContext,
  IReportBuilderDataSource,
  IReportingQuery,
} from '@principle-theorem/reporting/interfaces';
import { compact } from 'lodash';
import { ReportBuilderCharts } from '../data-sources/charts/report-builder-charts';
import { resolveCanBeChartedProperty } from './fact-table-resolvers';
import { getMeasureQueries } from './measure-results';
import { QueryFactory } from './query-factory';

export class ReportBuilderQueryBuilder {
  static getFilterQueries(
    dataSource: Pick<IReportBuilderDataSource, 'factTable'>,
    filters: ICustomReportFilter[],
    context: IAccessorContext
  ): IReportingQuery[] {
    return compact(
      filters.map((filter) => {
        const property = resolveCanBeChartedProperty(
          dataSource.factTable,
          filter.id
        );
        if (!property) {
          return;
        }
        const query = property.measure.filterAccessor(filter, context);
        if (!query) {
          return;
        }
        return QueryFactory.fromTable(dataSource.factTable.table)
          .filter(query)
          .merge([property.measure.query])
          .get();
      })
    );
  }

  static getTableQueries(
    dataSource: IReportBuilderDataSource,
    columns: ICustomReportColumn[]
  ): IReportingQuery[] {
    const queries = columns.map((column) => {
      const property = resolveCanBeChartedProperty(
        dataSource.factTable,
        column.id
      );
      return property?.measure.query;
    });
    return compact(queries);
  }

  static getChartQueries(
    dataSource: IReportBuilderDataSource,
    charts: ICustomReportChart[]
  ): IReportingQuery[] {
    const filterResults = charts.map((chart) =>
      ReportBuilderCharts.getFilterDefinition(dataSource, chart)
    );
    return compact(filterResults)
      .map((result) =>
        getMeasureQueries(result.config).map(
          (measureQuery) => measureQuery.query
        )
      )
      .flat();
  }
}
